import { useEffect } from 'react';
import useAuthStore from '@/stores/authStore';
import useSocketStore, {
  connect as socketConnect,
  disconnect as socketDisconnect,
  setToken as socketSetToken
} from '@/stores/socket';

/**
 * Manages socket connection lifecycle based on auth token presence.
 * Non-intrusive: can be added to AppProvider without behavior changes.
 */
export function useSocketLifecycle(): void {
  const token = useAuthStore(s => s.userInfo.token);
  const isHydrated = useAuthStore(s => s.isHydrated);
  const isConnected = useSocketStore(s => s.isConnected);

  useEffect(() => {
    if (!isHydrated) return;

    socketSetToken(token);

    if (token) {
      // Always call connect when token is present; the store handles "ignore if already connected with same token"
      socketConnect();
    } else if (isConnected) {
      // Only disconnect if token is empty and we are currently connected
      socketDisconnect();
    }
  }, [token, isHydrated, isConnected]);
}
